var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoiler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-28{fill:#f4c574;}.cls-29{fill:#facc7a;}.cls-30{fill:#eee;}.cls-31{fill:#ebebeb;}.cls-32{fill:#ecd096;}.cls-33{fill:#ec6a57;}.cls-34{fill:#eaeaea;}.cls-35{fill:#e9e9e9;}.cls-36{fill:#e9ce94;}.cls-37{fill:#eace95;}.cls-38{fill:#ececec;}.cls-39{fill:#fefefe;}.cls-40{fill:#fee0a1;}.cls-41{fill:#ebcf95;}.cls-42{fill:#fbd898;}.cls-43{fill:#305197;}.cls-44{fill:#d05e4c;}.cls-45{fill:#ce5d4c;}.cls-46{fill:#cd5d4b;}.cls-47{fill:#d15e4d;}.cls-48{fill:#41929d;}.cls-49{fill:#41939e;}.cls-50{fill:#3d8994;}.cls-51{fill:#31539a;}.cls-52{fill:#315298;}.cls-53{fill:#315299;}.cls-54{fill:#3c8892;}.cls-55{fill:#385dad;}.cls-56{fill:#3c8791;}.cls-57{fill:#3b8690;}.cls-12{clip-path:url(#clippath-13);}.cls-13{clip-path:url(#clippath-14);}.cls-14{clip-path:url(#clippath-12);}.cls-15{clip-path:url(#clippath-11);}.cls-16{clip-path:url(#clippath-18);}.cls-17{clip-path:url(#clippath-19);}.cls-18{clip-path:url(#clippath-17);}.cls-19{clip-path:url(#clippath-16);}.cls-20{clip-path:url(#clippath-10);}.cls-21{clip-path:url(#clippath-15);}.cls-22{clip-path:url(#clippath-22);}.cls-23{clip-path:url(#clippath-23);}.cls-24{clip-path:url(#clippath-24);}.cls-25{clip-path:url(#clippath-21);}.cls-26{clip-path:url(#clippath-20);}.cls-27{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.91,43.4c2.08-1.2,3.76-4.11,3.75-6.51.54.31,1.07.62,1.61.93,0,2.39-1.67,5.3-3.75,6.51-.48-.28-1.12-.65-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.85,39.94c.21-.12.42-.38.55-.78l1.61.93c-.12.4-.34.66-.55.78-.18.1-.35.11-.48.04l-1.61-.93c.13.07.3.06.48-.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.23,43.66c.69.4,1.64.34,2.68-.26l1.61.93c-1.05.6-2,.66-2.68.26-.48-.28-1.12-.65-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.66,36.89c0-1.19-.42-2.03-1.1-2.42l1.61.93c.68.39,1.1,1.23,1.1,2.42-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.98,40.91l-1.61-.93c-.21-.12-.28-.47.02-1.01l1.61.93c-.3.54-.23.89-.02,1.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.83,43.28c.54.31,1.07.62,1.61.93.22.5.55.88.96,1.12l-1.61-.93c-.41-.24-.74-.62-.96-1.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.51,33.45c.56-.07,1.07.03,1.49.28l1.61.93c-.42-.24-.93-.34-1.49-.28-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.83,43.28c-.06-.14-.12-.29-.16-.45.54.31,1.07.62,1.61.93.04.16.1.31.16.45-.21-.12-.42-.24-.63-.36-.16-.09-.33-.19-.49-.28-.04-.02-.09-.05-.13-.07s-.09-.05-.13-.07c-.02-.01-.04-.02-.06-.04-.06-.03-.13-.05-.17-.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.67,42.83c-.05-.19-.09-.39-.12-.6.54.31,1.07.62,1.61.93.03.21.07.41.12.6-.27-.16-.54-.31-.8-.47-.06-.04-.15-.09-.21-.12-.03-.02-.07-.04-.1-.06-.06-.04-.14-.08-.2-.12-.03-.02-.07-.04-.1-.06-.06-.03-.15-.06-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.56,34.47l1.61.93c-.68-.4-1.63-.34-2.67.26l-1.61-.93c1.05-.6,1.99-.66,2.67-.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.51,33.45s.03.02.04.03c.05.03.1.06.15.09.06.04.13.07.19.11.41.24.82.47,1.22.71-.33.04-.69.14-1.05.29-.54-.31-1.07-.62-1.61-.93.37-.16.72-.25,1.05-.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.2,33.86c.09-.04.17-.08.26-.12.54.31,1.07.62,1.61.93-.09.04-.17.08-.26.12-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.88,34.03c.11-.06.21-.12.31-.17.54.31,1.07.62,1.61.93-.1.05-.21.11-.31.17-.48-.28-1.12-.65-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.81,34.07s.05-.03.07-.04l1.61.93s-.05.03-.07.04c-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.83,44.59l-1.61-.93c-.68-.39-1.1-1.23-1.1-2.42,0-2.39,1.68-5.31,3.76-6.51l1.61.93c-2.08,1.2-3.77,4.12-3.76,6.51,0,1.19.42,2.02,1.1,2.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.52,41.59c0-.33.03-.68.08-1.02.54.31,1.07.62,1.61.93-.05.35-.08.69-.08,1.02,0,.22.01.44.04.64-.54-.31-1.07-.62-1.61-.93-.03-.2-.04-.41-.04-.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.82,39.54c.54.31,1.07.62,1.61.93-.1.34-.17.69-.23,1.02-.54-.31-1.07-.62-1.61-.93.05-.34.13-.68.23-1.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.26,35.33c.48-.5,1-.93,1.55-1.25.54.31,1.07.62,1.61.93-.55.33-1.07.75-1.55,1.25-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.82,39.54c.21-.74.53-1.48.93-2.18.54.31,1.07.62,1.61.93-.4.7-.71,1.44-.93,2.18-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.26,35.33c.54.31,1.07.62,1.61.93-.54.56-1.02,1.2-1.43,1.89-.54-.31-1.07-.62-1.61-.93.41-.69.89-1.34,1.43-1.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.75,37.37s.06-.1.08-.14c.54.31,1.07.62,1.61.93-.03.05-.06.1-.08.14-.54-.31-1.07-.62-1.61-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.19,49.79l.97.57c-.35-.2-.84-.17-1.37.13l-.97-.57c.53-.31,1.02-.34,1.37-.13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.44,55.03l-.97-.57c-.34-.2-.56-.63-.56-1.23,0-1.22.86-2.7,1.92-3.31l.97.57c-1.06.61-1.92,2.09-1.92,3.31,0,.61.22,1.03.56,1.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.49,47.07l.97.57c-.35-.2-.83-.17-1.37.14l-.97-.57c.54-.31,1.02-.34,1.37-.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.73,52.32l-.97-.57c-.34-.2-.56-.62-.56-1.23,0-1.23.86-2.71,1.92-3.32l.97.57c-1.06.61-1.92,2.09-1.92,3.32,0,.6.21,1.03.56,1.23Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CH_Boiler"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m71.97,86.03c0,1.17-.28,2.32-.82,3.4-.6,1.28-1.56,2.49-2.8,3.59-4.67,4.18-13.38,6.99-23.35,6.99s-18.68-2.8-23.34-6.99c-1.24-1.1-2.21-2.3-2.8-3.59-.54-1.09-.82-2.23-.82-3.4,0-7.72,12.07-13.99,26.96-13.99s26.97,6.27,26.97,13.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m71.97,17.84v5.25c0,.97-.23,1.92-.68,2.82-.5,1.07-1.29,2.07-2.32,2.97-3.87,3.47-11.1,5.8-19.37,5.8s-15.5-2.33-19.37-5.8c-1.03-.91-1.83-1.91-2.32-2.97-.44-.9-.68-1.85-.68-2.82v-5.25c0,.9.2,1.78.57,2.62t0,0c2.3,5.14,11.19,8.97,21.8,8.97s19.51-3.83,21.8-8.97h0c.38-.85.58-1.73.58-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m71.97,83.16v5.25c0,.97-.23,1.92-.68,2.82-.5,1.07-1.29,2.07-2.32,2.97-3.87,3.47-11.1,5.8-19.37,5.8s-15.5-2.33-19.37-5.8c-1.03-.91-1.83-1.91-2.32-2.97-.44-.9-.68-1.85-.68-2.82v-5.25c0,.9.2,1.78.57,2.62t0,0c2.3,5.14,11.19,8.97,21.8,8.97s19.51-3.83,21.8-8.97h0c.38-.85.58-1.73.58-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m71.97,17.84c0,.9-.2,1.78-.58,2.62h0c-2.3,5.15-11.19,8.97-21.8,8.97s-19.5-3.83-21.8-8.97t0,0c-.37-.84-.57-1.72-.57-2.62,0-3.98,3.87-7.49,9.77-9.58v4.81c0,.14.01.28.03.42.42,3.41,5.89,6.11,12.57,6.11s12.16-2.7,12.58-6.11c.02-.14.03-.28.03-.42v-4.81c5.9,2.09,9.77,5.6,9.77,9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m62.19,6.05v7.02c0,3.61-5.64,6.53-12.6,6.53s-12.6-2.92-12.6-6.53v-6.46c.13-.05.36,1.47.38,1.52.28.6.73,1.16,1.31,1.68,2.18,1.95,6.25,3.27,10.91,3.27s8.73-1.31,10.91-3.27c.58-.51,1.03-1.08,1.31-1.68.13.04.26-2.13.38-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m71.97,21.76v63.42c0,6.4-10.02,11.6-22.38,11.6s-22.37-5.19-22.37-11.6V21.76c0,.97.23,1.92.68,2.82.5,1.07,1.29,2.07,2.32,2.97,3.87,3.47,11.09,5.8,19.37,5.8s15.5-2.33,19.37-5.8c1.03-.91,1.83-1.91,2.32-2.97.44-.9.68-1.85.68-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m62.19,6.54c0,.55-.13,1.08-.38,1.59-.28.6-.73,1.16-1.31,1.68-2.18,1.95-6.25,3.27-10.91,3.27s-8.73-1.31-10.91-3.27c-.58-.51-1.03-1.08-1.31-1.68-.25-.51-.38-1.04-.38-1.59C36.99,2.93,42.63,0,49.59,0s12.6,2.93,12.6,6.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m64.51,44.33l-1.61-.93c.33-.19.64-.42.94-.68l1.61.93c-.3.26-.62.49-.94.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m65.46,43.65l-1.61-.93c.4-.35.77-.75,1.1-1.19l1.61.93c-.33.44-.7.85-1.1,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m66.56,42.45l-1.61-.93c.82-1.09,1.42-2.42,1.63-3.68l1.61.93c-.21,1.26-.81,2.59-1.63,3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m68.19,38.77l-1.61-.93c.05-.32.08-.64.08-.95,0-.17,0-.33-.03-.49l1.61.93c.02.16.03.32.03.49,0,.31-.03.63-.08.95"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m63.98,40.91l-1.61-.93c.12.07.29.06.46-.02l1.61.93c-.17.09-.34.09-.46.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m64.44,40.89l-1.61-.93s.02,0,.02-.01c.05-.03.09-.06.14-.1l1.61.93s-.09.07-.14.1c0,0-.02,0-.02.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m64.6,40.77l-1.61-.93c.05-.05.11-.1.16-.17l1.61.93c-.05.07-.1.12-.16.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m64.76,40.6l-1.61-.93c.1-.13.19-.3.25-.51l1.61.93c-.06.21-.15.38-.25.51"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m61.83,44.59l-1.61-.93c.65.38,1.54.35,2.53-.18l1.61.93c-.99.52-1.88.56-2.53.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m64.36,44.41l-1.61-.93c.05-.03.1-.06.15-.08l1.61.93c-.05.03-.1.06-.15.08"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m68.19,38.77l-1.61-.93c.05-.32.08-.64.08-.95,0-.17,0-.33-.03-.49l1.61.93c.02.16.03.32.03.49,0,.31-.03.63-.08.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m68.24,37.33l-1.61-.93c-.04-.4-.14-.75-.29-1.05l1.61.93c.14.3.24.65.29,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m67.95,36.28l-1.61-.93c-.19-.39-.46-.69-.79-.88l1.61.93c.33.19.6.49.79.88"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "65.01 40.09 63.4 39.16 64.35 35.71 65.95 36.64 65.01 40.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m63.98,40.91l-1.61-.93c-.06-.03-.1-.08-.14-.15l1.61.93c.03.07.08.12.14.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m63.84,40.76l-1.61-.93s-.04-.1-.04-.16l1.61.93c0,.06.02.11.04.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m63.8,40.6l-1.61-.93c0-.06,0-.13,0-.21l1.61.93c-.01.08-.01.15,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m63.81,40.4l-1.61-.93c.02-.14.08-.31.19-.5l1.61.93c-.11.19-.17.36-.19.5"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m65.95,36.64l-.95,3.45c-.12.4-.34.66-.55.78-.47.27-.94-.11-.46-.97l1.95-3.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "64 39.9 62.39 38.96 64.35 35.71 65.95 36.64 64 39.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m61.4,45.33l-1.61-.93c-.38-.22-.7-.57-.91-1.02l1.61.93c.22.45.53.8.91,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m60.49,44.31l-1.61-.93c-.17-.34-.28-.75-.33-1.22l1.61.93c.05.47.16.87.33,1.22"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m64.67,34.87l-1.61-.93c1.15-.61,2.18-.65,2.94-.21l1.61.93c-.76-.44-1.79-.4-2.94.21"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m60.49,44.31l-1.61-.93c-.17-.34-.28-.75-.33-1.22l1.61.93c.05.47.16.87.33,1.22"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m60.49,44.31l-1.61-.93c-.17-.34-.28-.75-.33-1.22l1.61.93c.05.47.16.87.33,1.22"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m64.49,35.66l-1.61-.93c.05-.03.1-.06.15-.08l1.61.93c-.05.03-.1.06-.15.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m64.64,35.58l-1.61-.93c.98-.52,1.87-.55,2.52-.18l1.61.93c-.65-.38-1.54-.35-2.52.18"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m64.67,34.87l-1.61-.93c1.15-.61,2.18-.65,2.94-.21l1.61.93c-.76-.44-1.79-.4-2.94.21"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m64.67,34.87l-1.61-.93c1.15-.61,2.18-.65,2.94-.21l1.61.93c-.76-.44-1.79-.4-2.94.21"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m64.49,34.96l-1.61-.93c.06-.03.12-.07.18-.1l1.61.93c-.06.03-.12.06-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m64.67,34.87l-1.61-.93c1.15-.61,2.18-.65,2.94-.21l1.61.93c-.76-.44-1.79-.4-2.94.21"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m63.39,35.76l-1.61-.93c.35-.31.72-.57,1.1-.79l1.61.93c-.38.22-.75.49-1.1.79"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m61.83,44.59l-1.61-.93c-.33-.19-.6-.49-.79-.88l1.61.93c.19.39.46.69.79.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m61.04,43.71l-1.61-.93c-.14-.3-.24-.65-.29-1.05l1.61.93c.04.4.14.75.29,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m60.76,42.66l-1.61-.93c-.02-.16-.03-.32-.03-.49,0-.31.03-.63.08-.95l1.61.93c-.05.32-.08.64-.08.95,0,.17,0,.33.03.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m60.81,41.23l-1.61-.93c.21-1.26.81-2.59,1.63-3.68l1.61.93c-.82,1.09-1.42,2.42-1.63,3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m62.44,37.54l-1.61-.93c.34-.44.71-.85,1.11-1.2l1.61.93c-.4.35-.77.75-1.11,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m63.55,36.35l-1.61-.93c.3-.26.62-.49.94-.68l1.61.93c-.33.19-.64.42-.94.68"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m60.49,44.31l-1.61-.93c-.17-.34-.28-.75-.33-1.22l1.61.93c.05.47.16.87.33,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m60.15,43.09l-1.61-.93c-.02-.18-.03-.37-.03-.57,0-.36.03-.73.09-1.1l1.61.93c-.06.37-.09.74-.09,1.1,0,.2.01.39.03.57"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m60.15,43.09l-1.61-.93c-.02-.18-.03-.37-.03-.57,0-.36.03-.73.09-1.1l1.61.93c-.06.37-.09.74-.09,1.1,0,.2.01.39.03.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.22,41.42l-1.61-.93c.24-1.47.94-3,1.89-4.27l1.61.93c-.96,1.27-1.65,2.8-1.89,4.27"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m62.11,37.15l-1.61-.93c.39-.52.82-.99,1.28-1.39l1.61.93c-.46.4-.89.88-1.28,1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m63.39,35.76l-1.61-.93c.35-.31.72-.57,1.1-.79l1.61.93c-.38.22-.75.49-1.1.79"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.22,41.42l-1.61-.93c.24-1.47.94-3,1.89-4.27l1.61.93c-.96,1.27-1.65,2.8-1.89,4.27"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.22,41.42l-1.61-.93c.24-1.47.94-3,1.89-4.27l1.61.93c-.96,1.27-1.65,2.8-1.89,4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m62.11,37.15l-1.61-.93c.39-.52.82-.99,1.28-1.39l1.61.93c-.46.4-.89.88-1.28,1.39"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m64.49,34.96c2.42-1.4,4.39-.28,4.39,2.5s-1.95,6.16-4.36,7.56-4.39.28-4.39-2.5,1.95-6.16,4.36-7.56Zm.03,9.36c2.08-1.2,3.76-4.11,3.75-6.51s-1.69-3.36-3.78-2.16-3.77,4.12-3.76,6.51,1.7,3.36,3.78,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m64.49,35.66c2.08-1.2,3.77-.23,3.78,2.16s-1.67,5.3-3.75,6.51-3.78.24-3.78-2.16,1.68-5.31,3.76-6.51Zm.52,4.43l.95-3.45-1.95,3.26c-.48.86,0,1.24.46.97.21-.12.42-.38.55-.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.22,41.42l-1.61-.93c.24-1.47.94-3,1.89-4.27l1.61.93c-.96,1.27-1.65,2.8-1.89,4.27"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m62.79,50.49l-.97-.57c.18-.1.36-.18.52-.22l.97.57c-.17.04-.34.11-.52.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m63.32,50.27l-.97-.57c.2-.05.39-.06.56-.02l.97.57c-.17-.04-.36-.03-.56.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m63.88,50.25l-.97-.57c.1.02.2.06.28.11l.97.57c-.09-.05-.18-.09-.28-.11"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m61.44,55.03l-.97-.57c-.34-.2-.56-.63-.56-1.23,0-.17.02-.34.05-.52l.97.57c-.03.18-.05.35-.05.52,0,.61.22,1.03.56,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m60.92,53.28l-.97-.57c.05-.26.13-.53.23-.79l.97.57c-.11.26-.18.53-.23.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m61.15,52.49l-.97-.57c.15-.36.34-.71.58-1.02l.97.57c-.23.31-.43.66-.58,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m61.73,51.47l-.97-.57c.22-.3.48-.57.75-.77l.97.57c-.28.21-.53.48-.75.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m62.49,50.69l-.97-.57c.1-.08.2-.14.31-.2l.97.57c-.1.06-.21.13-.31.2"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m62.79,50.49c1.06-.61,1.93-.13,1.93,1.09s-.86,2.71-1.92,3.32-1.93.13-1.93-1.1.86-2.7,1.92-3.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m69.09,47.78l-.97-.57c.18-.11.36-.18.53-.22l.97.57c-.17.04-.34.12-.53.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m69.62,47.56l-.97-.57c.2-.05.39-.06.56-.02l.97.57c-.17-.04-.36-.03-.56.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m70.18,47.53l-.97-.57c.1.02.2.06.28.11l.97.57c-.09-.05-.18-.09-.28-.11"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m67.73,52.32l-.97-.57c-.34-.2-.56-.62-.56-1.23,0-.17.02-.35.05-.53l.97.57c-.03.18-.05.36-.05.53,0,.6.21,1.03.56,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m67.22,50.57l-.97-.57c.05-.26.13-.53.23-.79l.97.57c-.11.26-.19.53-.23.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m67.46,49.78l-.97-.57c.15-.36.34-.71.58-1.02l.97.57c-.23.31-.43.66-.58,1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m68.03,48.76l-.97-.57c.22-.3.48-.56.75-.77l.97.57c-.28.21-.53.47-.75.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m68.79,47.98l-.97-.57c.1-.08.2-.14.31-.2l.97.57c-.1.06-.21.13-.31.2"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m69.09,47.78c1.07-.62,1.93-.13,1.93,1.1s-.85,2.7-1.92,3.31-1.93.13-1.93-1.09.86-2.71,1.92-3.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiler);
export default __webpack_public_path__ + "static/media/boiler.1b674a6b123bc772a1390133a998dda4.svg";
export { ForwardRef as ReactComponent };